import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { getProfiles } from './profiles';

const formSelector = formValueSelector('login');

const getIsButtonDisabled = state =>
  !formSelector(state, 'email') || !formSelector(state, 'password');

const getHasToken = state => state.auth.hasToken;
const getIsIncorrectMessageVisible = state =>
  state.auth.isIncorrectPasswordMessageVisible;

export const getIsConnectionFailedMessageVisible = state =>
  state.auth.isConnectionFailedMessageVisible;

export const getIsUnauthorizedMessageVisible = state =>
  state.auth.isUnauthorizedMessageVisible;

const getIsLoading = state => state.auth.isFetching;
const getPage = state => (!state.auth.hasToken ? 'login' : 'profile');

const getLogin = createSelector(
  getHasToken,
  getIsButtonDisabled,
  getIsLoading,
  getIsIncorrectMessageVisible,
  getIsUnauthorizedMessageVisible,
  getIsConnectionFailedMessageVisible,
  getPage,
  getProfiles,
  (
    hasToken,
    isButtonDisabled,
    isLoading,
    isIncorrectPasswordMessageVisible,
    isConnectionFailedMessageVisible,
    isUnauthorizedMessageVisible,
    page,
    profiles
  ) => ({
    hasToken,
    isButtonDisabled,
    isLoading,
    isIncorrectPasswordMessageVisible,
    isConnectionFailedMessageVisible,
    isUnauthorizedMessageVisible,
    page,
    profiles
  })
);

export { getLogin };



// WEBPACK FOOTER //
// ./src/selectors/login.js